module.exports = __webpack_public_path__ + "files/fd23c7c7d61d0cdd3b99e011d9c4b351.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/exo2-bold-webfont.ttf
// module id = 667
// module chunks = 60